export const Layouts = {
    TOPNAV : "TOPNAV",
    LEFTNAV : "LEFTNAV"
}